export default function initLecteurVideo() {
    const lecteursVideos = document.querySelectorAll('.block-lecteur-video');

    if (!lecteursVideos) {
        return;
    }

    const videosPlayers = document.querySelectorAll('.video[data-video-id]');

    videosPlayers.forEach((videoPlayer) => {
        videoPlayer
            .querySelector('iframe')
            .setAttribute('data-src', videoPlayer.querySelector('iframe').getAttribute('src'));
    });

    lecteursVideos.forEach((lecteurVideo) => {
        const videosNav = lecteurVideo.querySelectorAll('.video-nav a[data-video-id]');

        const scopedVideosPlayers = lecteurVideo.querySelectorAll('.video[data-video-id]');

        videosNav.forEach((videoNav) => {
            videoNav.addEventListener('click', (e) => {
                e.preventDefault();
                const videoId = videoNav.getAttribute('data-video-id');

                videosNav.forEach((videoNav) => {
                    if (videoNav.getAttribute('data-video-id') === videoId) {
                        videoNav.classList.add('is-active');
                    } else {
                        videoNav.classList.remove('is-active');
                    }
                });

                scopedVideosPlayers.forEach((videoPlayer) => {
                    if (videoPlayer.getAttribute('data-video-id') === videoId) {
                        videoPlayer.classList.add('is-active');
                        videoPlayer
                            .querySelector('iframe')
                            .setAttribute(
                                'src',
                                videoPlayer.querySelector('iframe').getAttribute('data-src')
                            );

                        const isMobile = window.matchMedia('(max-width: 767px)').matches;

                        if (isMobile) {
                            // Scroll to video smooth
                            const videoPlayerOffsetTop = videoPlayer.offsetTop + 200;
                            const adminBarHeight = 0;

                            window.scrollTo({
                                top: videoPlayerOffsetTop - adminBarHeight,
                                behavior: 'smooth',
                            });
                        }
                    } else {
                        videoPlayer.classList.remove('is-active');
                        videoPlayer.querySelector('iframe').setAttribute('src', '');
                    }
                });
            });
        });
    });
}
